module.exports = __webpack_public_path__ + "img/Marca5.25619855.jpg";